import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ROUTES } from '@/shared/config/routes';
import { useContentStudioAllowed } from '@/shared/config/useContentStudioAllowed';

interface ContentStudioRouteGuardProps {
  children: ReactNode;
}

/**
 * `isAllowed` reads false while the ACL check is still in flight, so the loading branch
 * must render nothing rather than redirect: collapsing it into the `!isAllowed` redirect
 * bounces an allowed user home before visibility has resolved.
 */
export const ContentStudioRouteGuard = ({ children }: ContentStudioRouteGuardProps) => {
  const { isAllowed, isLoading } = useContentStudioAllowed();

  if (isLoading) {
    return null;
  }

  if (!isAllowed) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <>{children}</>;
};
